import { html, TemplateResult, css } from 'lit';
import { Styles } from '../types/types';

export const fontTypeComponent:
    (onClick: (value: Styles["font-family"]) => void) => TemplateResult<1>
    = (onClick) => {
        return (
            html`
            <div class="font-size buttons">
                <button style="font-family: Arial" @click=${() => onClick("1em")} part="button">A</button>
                <button @click=${() => onClick("2em")} part="button">2x</button>
                <button @click=${() => onClick("3em")} part="button">3x</button>
                <button @click=${() => onClick("4em")} part="button">4x</button>
            </div>`
        )
    }

export const fontFamilyStyles = css`
    .font-size button {
        border-radius: 20px;
        width: 20px;
        height: 20px;
        border: none;
    }
    .font-size button:hover {
        box-shadow: 2px 2px 3px 2px rgba(0,0,0,.1);
        opacity: 1;
    }
`